import {Routes} from 'navigation/Routes';
import {IconType} from './icons';
import {userRole} from './enums';
import {
  ORG_ADMIN,
  ORG_SUPER_ADMIN,
  ORG_EMPLOYEE,
  APP_SUPER_ADMIN,
} from './keys';

export type navProps = {
  label: string;
  icon: IconType;
  iconActive: IconType;
  route: string;
  onPress?: () => void;
};

const roles = Object.values(userRole);
type menuConfigType = Record<Partial<(typeof roles)[number]>, navProps[]>;

function allCommonMenu(other: navProps[]): navProps[] {
  return [
    {
      label: 'Home',
      icon: 'home_gray',
      iconActive: 'home_white',
      route: Routes.DASHBOARD,
    },
    ...other,
    {
      label: 'Account Settings',
      icon: 'account_settings_gray',
      iconActive: 'account_settings_white',
      route: Routes.MY_PROFILE,
    },
  ];
}

const commonEmployeeMenu: navProps[] = [
  {
    route: Routes.SETTINGS,
    label: 'Training',
    iconActive: 'training_white',
    icon: 'training_gray',
  },
  {
    route: Routes.SETTINGS,
    icon: 'documentation_gray',
    iconActive: 'documentation_white',
    label: 'Documentation',
  },
  {
    route: Routes.SETTINGS,
    icon: 'assets_gray',
    iconActive: 'assets_white',
    label: 'Assets',
  },
  {
    route: Routes.SETTINGS,
    icon: 'forum_gray',
    iconActive: 'forum_white',
    label: 'Forums',
  },
  {
    route: Routes.SETTINGS,
    icon: 'chat_gray',
    iconActive: 'chat_white',
    label: 'Chat',
  },
];

export const MENU_CONFIG: menuConfigType = {
  [userRole[APP_SUPER_ADMIN]]: [
    ...allCommonMenu([
      {
        label: 'Manage Organizations',
        icon: 'manage_org_gray',
        iconActive: 'manage_org_white',
        route: Routes.SETTINGS,
      },
    ]),
  ],
  [userRole[ORG_SUPER_ADMIN]]: [
    ...allCommonMenu([
      {
        label: 'Projects',
        icon: 'projects_gray',
        iconActive: 'projects_white',
        route: Routes.PROJECT,
      },
      {
        label: 'Team',
        icon: 'team_gray',
        iconActive: 'team_white',
        route: Routes.TEAM,
      },
      {
        label: 'Organization Settings',
        icon: 'organisation_settings_gray',
        iconActive: 'organisation_settings_white',
        route: Routes.SETTINGS,
      },
      ...commonEmployeeMenu,
    ]),
  ],
  [userRole[ORG_EMPLOYEE]]: [
    ...allCommonMenu([
      {
        label: 'Projects',
        icon: 'projects_gray',
        iconActive: 'projects_white',
        route: Routes.PROJECT,
      },
      ...commonEmployeeMenu,
    ]),
  ],
  [userRole[ORG_ADMIN]]: [],
} as const;
